import { useMemo } from "react";

/**
 * Floating incense-like dust motes.
 * Pure CSS-animated absolute divs, GPU-accelerated, cheap on mobile.
 */
export default function Particles({ count = 14 }) {
  const particles = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const size = 1.5 + Math.random() * 2.5;
        const left = Math.random() * 100;
        const delay = -Math.random() * 20;
        const duration = 22 + Math.random() * 18;
        const drift = (Math.random() - 0.5) * 60;
        return { id: i, size, left, delay, duration, drift };
      }),
    [count]
  );

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[1] overflow-hidden"
      aria-hidden
    >
      {particles.map((p) => (
        <span
          key={p.id}
          className="particle"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            "--drift": `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
